import { onBeforeUnmount, ref } from "vue";
import { dataLayerSearchWidgetAbandonment } from "@/analytics/package-search-form";
import { useQueryStore } from "@/stores/query";
import { getEnvVar } from "@/utils/env";

export function useAnalyticsAbandonment(tabConfigId: string) {
  const timeoutId = ref<NodeJS.Timeout | null>(null);

  const queryStore = useQueryStore(tabConfigId);

  const clearAnalyticsTimeout = () => {
    if (timeoutId.value) {
      clearTimeout(timeoutId.value);
      timeoutId.value = null;
    }
  };

  const pushEvent = (isAbandonnedByClick: boolean) => {
    dataLayerSearchWidgetAbandonment(
      queryStore.query.departureLocation,
      queryStore.query.arrivalLocation,
      queryStore.query.dateRange,
      queryStore.query.guests,
      queryStore.query.cabinClass,
      isAbandonnedByClick
    );
  };

  const setAnalyticsTimeout = () => {
    const timeoutDelay =
      getEnvVar("VITE_ANALYTICS_ABANDONMENT_TIMEOUT") ?? 180000; // 180000 = 3 minutes
    clearAnalyticsTimeout();
    timeoutId.value = setTimeout(() => {
      pushEvent(false);
    }, timeoutDelay);
  };

  const sendAnalyticsAbandonment = () => {
    if (timeoutId.value) {
      pushEvent(true);
    }
    clearAnalyticsTimeout();
  };

  onBeforeUnmount(() => {
    clearAnalyticsTimeout();
  });

  return {
    clearAnalyticsTimeout,
    setAnalyticsTimeout,
    sendAnalyticsAbandonment,
  };
}
